import { render, staticRenderFns } from "./allocateDialog.vue?vue&type=template&id=eb4541fa&scoped=true&"
import script from "./allocateDialog.vue?vue&type=script&lang=js&"
export * from "./allocateDialog.vue?vue&type=script&lang=js&"
import style0 from "./allocateDialog.vue?vue&type=style&index=0&id=eb4541fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb4541fa",
  null
  
)

export default component.exports